export function normalizeRole(value) {
  return (value || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");
}

export function normalizeUserType(value) {
  return (value || "").toString().trim().toLowerCase();
}

export function getPortalRoute(apiData, options = {}) {
  const fallback = options.fallback || "/access-denied";
  const role = normalizeRole(apiData?.ROLE || apiData?.role);

  if (role === "app-admin") return "/app-admin";
  if (role === "admin") return "/management";
  if (role === "service-staff") return "/service-staff";
  if (role === "resident") return "/resident";
  // Non-resident users use resident portal with owner-limited visibility.
  if (role === "non-resident") return "/resident";

  return fallback;
}

export function isRouteAllowedForRole(apiData, expectedRoute) {
  const resolved = getPortalRoute(apiData, { fallback: "/access-denied" });
  return resolved === expectedRoute;
}
